var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _image, _image2, _image3, _image4, _image5, _image6, _image7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFdImgMissionMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 223 185",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.742,83.179c-0.02,-5.847 1.38,-11.612 4.08,-16.8c1.281,-2.436 2.45,-3.95 3.36,-4.879c0.703,-0.746 1.802,-0.963 2.736,-0.54c0.364,0.128 0.692,0.341 0.96,0.619c1.216,1.26 2.316,2.926 3.276,4.699c2.839,5.309 4.313,11.241 4.288,17.261l0,3.615l2.319,0l0,-42c0,-8.804 1.97,-17.489 5.829,-25.2c1.829,-3.651 3.497,-5.919 4.781,-7.313c0.63,-0.717 1.537,-1.128 2.491,-1.128c0.954,0 1.862,0.411 2.492,1.128c1.737,1.889 3.304,4.385 4.675,7.039c4.058,7.87 6.12,16.8 6.12,25.865l0,41.609l2.004,0l0,-3.788c-0.025,-6.02 1.449,-11.952 4.289,-17.26c0.96,-1.772 2.059,-3.437 3.276,-4.7c0.718,-0.756 1.844,-0.962 2.784,-0.508l-0.084,0.045c0.293,0.13 0.559,0.316 0.782,0.547c0.9,0.929 2.069,2.444 3.36,4.88c2.699,5.187 4.099,10.952 4.08,16.8l0,62.793l-7.152,0l0.78,5.163l0,15.434l-5.846,0l0,-15.434l0.78,-5.163l-7.049,0l0,-57.185l-2.004,0l0,56.928l-5.712,0l0.821,5.417l0,15.437l-5.849,0l0,-15.434l0.821,-5.417l-7.697,0l0.821,5.417l0,15.434l-5.849,0l0,-15.434l0.821,-5.417l-4.56,0l0,-56.931l-2.319,0l0,57.272l-1.879,0l0,-0.087l-6.214,0l0.78,5.163l0,15.434l-5.848,0l0,-15.434l0.78,-5.163l-6.324,0l0,-62.784Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 0,
    y: 0,
    width: "848px",
    height: "1938px",
    transform: "matrix(-0.998512,0,-0,-1.00031,149.64,166.56)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M136.258,148.116l5.536,0l-0.988,-6.722l-3.56,0l-0.988,6.722Z",
    style: {
      fill: "#666774",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.082,144.062l-4.112,0l0.276,-1.879l3.56,0l0.276,1.879Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.795,148.116l5.537,0l-0.989,-6.722l-3.559,0l-0.989,6.722Z",
    style: {
      fill: "#666774",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.619,144.062l-4.111,0l0.276,-1.879l3.559,0l0.276,1.879Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.26,148.116l5.539,0l-0.989,-6.722l-3.561,0l-0.989,6.722Z",
    style: {
      fill: "#666774",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.086,144.062l-4.113,0l0.276,-1.879l3.561,0l0.276,1.879Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.99,148.116l5.536,0l-0.988,-6.722l-3.56,0l-0.988,6.722Z",
    style: {
      fill: "#666774",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.814,144.062l-4.114,0l0.278,-1.879l3.56,0l0.276,1.879Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 96.706,
    y: 85.822,
    width: 39.552,
    height: 1.582,
    style: {
      fill: "#666774"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.59,60.83c0.423,-0.466 1.023,-0.732 1.653,-0.732c0.629,0 1.23,0.266 1.652,0.732c1.152,1.227 2.191,2.849 3.101,4.575c2.692,5.189 4.084,10.954 4.058,16.8l0,60.885l-17.503,0l0,-61.137c-0.022,-5.686 1.303,-11.296 3.867,-16.371c1.214,-2.371 2.32,-3.847 3.172,-4.752Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.782,60.83c-0.423,-0.466 -1.023,-0.732 -1.653,-0.732c-0.629,0 -1.23,0.266 -1.652,0.732c-1.152,1.227 -2.191,2.849 -3.101,4.575c-2.692,5.189 -4.084,10.954 -4.058,16.8l0,60.885l17.508,0l0,-61.137c0.022,-5.686 -1.303,-11.296 -3.867,-16.371c-1.212,-2.371 -2.318,-3.847 -3.177,-4.752Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.477,83.251l-4.152,0.019l0,5.122l4.152,0l0,-5.141Z",
    style: {
      fill: "#666774",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.057,83.251l-4.155,0.019l0,5.122l4.155,0l0,-5.141Z",
    style: {
      fill: "#666774",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.383,65.326c0.907,-1.726 1.949,-3.348 3.101,-4.575c0.669,-0.739 1.748,-0.942 2.64,-0.497c-0.25,0.125 -0.476,0.293 -0.667,0.497c-1.152,1.227 -2.191,2.849 -3.101,4.575c-2.692,5.189 -4.084,10.954 -4.058,16.8l0,60.88l-1.978,0l0,-60.873c-0.026,-5.849 1.369,-11.616 4.063,-16.807Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.422,65.494c-0.908,-1.726 -1.949,-3.348 -3.101,-4.575c-0.216,-0.232 -0.476,-0.418 -0.766,-0.547c0.878,-0.384 1.902,-0.164 2.544,0.547c1.152,1.227 2.191,2.849 3.101,4.575c2.692,5.189 4.084,10.954 4.058,16.8l0,60.88l-1.78,0l0,-60.871c0.028,-5.849 -1.364,-11.617 -4.056,-16.809Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 136.258,
    y: 148.116,
    width: 5.537,
    height: 15.029,
    style: {
      fill: "url(#_Linear3)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.262,
    y: 148.116,
    width: 5.537,
    height: 15.029,
    style: {
      fill: "url(#_Linear4)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.99,
    y: 148.116,
    width: 5.537,
    height: 15.029,
    style: {
      fill: "url(#_Linear5)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.795,
    y: 148.116,
    width: 5.537,
    height: 15.029,
    style: {
      fill: "url(#_Linear6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.494,13.094c0.585,-0.695 1.448,-1.097 2.358,-1.097c0.909,0 1.772,0.402 2.358,1.097c1.644,1.839 3.12,4.27 4.425,6.857c3.84,7.666 5.794,16.366 5.794,25.188l0,97.702l-24.982,0l0,-98.095c0,-8.573 1.865,-17.04 5.52,-24.531c1.731,-3.554 3.31,-5.762 4.527,-7.121Z",
    style: {
      fill: "#f1f1f1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.988,23.947l-7.754,0c-1.458,0 -2.64,1.182 -2.64,2.64l0,0.694c0,1.458 1.182,2.64 2.64,2.64l7.754,0c1.458,0 2.64,-1.182 2.64,-2.64l0,-0.694c0,-1.458 -1.182,-2.64 -2.64,-2.64Z",
    style: {
      fill: "#8776d9",
      fillRule: "nonzero"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.742,161.503c1.7,-10.25 10.992,-17.472 21.345,-16.588c10.352,0.883 18.287,9.575 18.226,19.965l0,0.293c0.737,0.111 1.466,0.268 2.184,0.468c1.884,-7.504 8.307,-12.997 16.012,-13.695c7.706,-0.697 15.01,3.553 18.212,10.596c1.61,-0.621 3.301,-1.007 5.021,-1.147c0.274,-1.557 0.734,-3.076 1.37,-4.524c0.619,-9.473 8.419,-16.878 17.913,-17.004c9.493,-0.125 17.486,7.07 18.356,16.524c0.942,1.996 1.544,4.135 1.781,6.329c8.63,3.591 13.14,13.132 10.437,22.08l-145.819,0c-1.538,-5.099 -0.767,-10.616 2.111,-15.097c2.878,-4.481 7.574,-7.478 12.851,-8.2Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.004,
    y: 139.866,
    width: 147.377,
    height: 44.934
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image9",
    x: 42.182,
    y: 140.07,
    width: "147.377px",
    height: "44.934px",
    transform: "matrix(0.995787,0,0,0.998544,-2.4869e-14,0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M139.114,158.232c0,-9.647 7.832,-17.479 17.479,-17.479c9.647,0 17.479,7.832 17.479,17.479c0,9.647 -7.832,17.479 -17.479,17.479c-9.647,0 -17.479,-7.832 -17.479,-17.479Z",
    style: {
      fill: "url(#_Linear10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.539,164.786c0,-10.563 8.577,-19.14 19.14,-19.14c10.564,0 19.14,8.577 19.14,19.14c0,10.564 -8.576,19.14 -19.14,19.14c-10.563,0 -19.14,-8.576 -19.14,-19.14Z",
    style: {
      fill: "url(#_Linear11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.755,164.786c0,-10.563 8.577,-19.14 19.14,-19.14c10.564,0 19.14,8.577 19.14,19.14c0,10.564 -8.576,19.14 -19.14,19.14c-10.563,0 -19.14,-8.576 -19.14,-19.14Z",
    style: {
      fill: "url(#_Linear12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.378,166.447c0,-9.647 7.833,-17.479 17.48,-17.479c9.647,0 17.479,7.832 17.479,17.479c0,9.647 -7.832,17.479 -17.479,17.479c-9.647,0 -17.48,-7.832 -17.48,-17.479Z",
    style: {
      fill: "url(#_Linear13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.61,169.769c-0.006,5.607 2.683,10.876 7.228,14.16l20.504,0c6.697,-4.841 9.091,-13.708 5.741,-21.262c-3.35,-7.554 -11.531,-11.731 -19.614,-10.016c-8.083,1.715 -13.863,8.855 -13.857,17.118l-0.002,0Z",
    style: {
      fill: "url(#_Linear14)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.807,178.858c-0.002,1.717 0.251,3.425 0.749,5.068l33.463,0c1.595,-5.277 0.607,-10.998 -2.666,-15.434c-3.273,-4.437 -8.448,-7.069 -13.961,-7.102l-0.108,-0.012c-0.49,0 -0.975,0.02 -1.457,0.06c-1.651,0.135 -3.275,0.506 -4.821,1.102c-6.749,2.6 -11.2,9.086 -11.199,16.318Z",
    style: {
      fill: "url(#_Linear15)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.933,182.354c0,0.524 0.023,1.041 0.069,1.553c-0.001,0.007 -0.001,0.015 0,0.022l34.82,0c0.048,-0.519 0.072,-1.044 0.072,-1.572c0.006,-8.644 -6.313,-15.992 -14.861,-17.28c-0.865,-0.13 -1.737,-0.196 -2.611,-0.197c-0.447,0 -0.891,0.017 -1.33,0.048c-6.382,0.488 -11.987,4.422 -14.616,10.258c-0.072,0.158 -0.142,0.319 -0.206,0.48c-0.883,2.119 -1.337,4.392 -1.337,6.688Z",
    style: {
      fill: "url(#_Linear16)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.897,178.858c-0.002,1.717 0.25,3.425 0.749,5.068l33.456,0c0.808,-2.687 0.962,-5.53 0.448,-8.289c-0.028,-0.151 -0.057,-0.305 -0.091,-0.454c-1.735,-8.052 -8.855,-13.802 -17.093,-13.802c-0.549,0 -1.089,0.024 -1.624,0.077c-0.24,0.019 -0.48,0.048 -0.72,0.079c-8.664,1.179 -15.125,8.577 -15.125,17.321Z",
    style: {
      fill: "url(#_Linear17)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.27,183.929c-0.057,-0.183 -0.108,-0.365 -0.158,-0.55c-1.62,-6.057 0.127,-12.519 4.579,-16.935c4.451,-4.416 10.926,-6.112 16.971,-4.444c0.695,0.191 1.377,0.427 2.042,0.706c8.293,3.45 12.626,12.618 10.027,21.216l-33.461,0l0,0.007Z",
    style: {
      fill: "url(#_Linear18)",
      fillRule: "nonzero"
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.334,144.773c0,1.771 1.435,3.206 3.206,3.206c1.771,0 3.206,-1.435 3.206,-3.206c0,-1.771 -1.435,-3.207 -3.206,-3.207c-1.771,0 -3.206,1.436 -3.206,3.207Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip19)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image20",
    x: 0,
    y: 0,
    width: "80px",
    height: "80px",
    transform: "matrix(-1.0688,0,-0,-1.0688,54.7464,147.979)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M48.569,144.773c0,-1.64 1.331,-2.971 2.971,-2.971c1.64,0 2.971,1.331 2.971,2.971c0,1.64 -1.331,2.971 -2.971,2.971c-1.64,0 -2.971,-1.331 -2.971,-2.971Z",
    style: {
      fill: "url(#_Linear21)"
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.36,175.711c0,1.931 1.566,3.497 3.497,3.497c1.931,0 3.497,-1.566 3.497,-3.497c0,-1.931 -1.566,-3.497 -3.497,-3.497c-1.931,0 -3.497,1.566 -3.497,3.497Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip22)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image23",
    x: 0,
    y: 0,
    width: "87px",
    height: "87px",
    transform: "matrix(-0.999086,0,-0,-0.999086,40.3536,179.208)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M33.535,175.711c0,-1.833 1.489,-3.321 3.322,-3.321c1.833,0 3.321,1.488 3.321,3.321c0,1.833 -1.488,3.322 -3.321,3.322c-1.833,0 -3.322,-1.489 -3.322,-3.322Z",
    style: {
      fill: "url(#_Linear24)"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.64,155.784c0,2.122 1.72,3.842 3.842,3.842c2.123,0 3.843,-1.72 3.843,-3.842c0,-2.122 -1.72,-3.842 -3.843,-3.842c-2.122,0 -3.842,1.72 -3.842,3.842Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip25)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image26",
    x: 0,
    y: 0,
    width: "96px",
    height: "96px",
    transform: "matrix(-0.9606,0,-0,-0.9606,190.325,159.626)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M182.813,155.784c0,-2.025 1.644,-3.67 3.669,-3.67c2.026,0 3.67,1.645 3.67,3.67c0,2.025 -1.644,3.67 -3.67,3.67c-2.025,0 -3.669,-1.645 -3.669,-3.67Z",
    style: {
      fill: "url(#_Linear27)"
    }
  }), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.726,4.181c0.852,-1.126 1.919,-2.07 3.14,-2.779c3.837,-2.205 8.642,-1.779 12.031,1.067c3.388,2.846 4.639,7.506 3.13,11.666c-1.509,4.16 -5.456,6.935 -9.881,6.947c-0.224,0 -0.447,0 -0.668,-0.022c-3.87,-0.244 -7.294,-2.595 -8.913,-6.119c-1.618,-3.524 -1.171,-7.653 1.166,-10.748l-0.005,-0.012Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip28)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image29",
    x: 0,
    y: 0,
    width: "263px",
    height: "263px",
    transform: "matrix(-1.00264,0,-0,-1.00389,60.6589,21.0817)"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.178,10.529c0,5.257 4.085,9.61 9.332,9.943c0.208,0.014 0.42,0.022 0.631,0.022c4.187,-0.003 7.925,-2.623 9.356,-6.557c1.431,-3.935 0.25,-8.345 -2.957,-11.036c-3.207,-2.692 -7.755,-3.092 -11.382,-1c-1.154,0.67 -2.163,1.563 -2.968,2.628c-1.308,1.726 -2.015,3.834 -2.012,6Z",
    style: {
      fill: "#8776d9",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.594,4.21c0.514,0.222 1.011,0.483 1.485,0.782c0.317,0.176 0.589,0.422 0.795,0.72c0.205,0.305 0.212,0.702 0.019,1.015c-0.24,0.331 -0.72,0.384 -1.121,0.406c-0.75,0.159 -1.528,-0.098 -2.035,-0.672l-0.857,-0.778c-0.298,-0.269 -0.624,-0.641 -0.494,-1.02c0.098,-0.29 0.424,-0.432 0.72,-0.48c0.736,-0.145 1.5,-0.01 2.143,0.377",
    style: {
      fill: "#f97655",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.649,14.462c0,-0.288 0.234,-0.523 0.523,-0.523c0.289,0 0.523,0.235 0.523,0.523c0,0.289 -0.234,0.524 -0.523,0.524c-0.289,0 -0.523,-0.235 -0.523,-0.524Z",
    style: {
      fill: "#f97655"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.586,11.141c0,-1.061 0.862,-1.923 1.923,-1.923c1.061,0 1.922,0.862 1.922,1.923c0,1.061 -0.861,1.922 -1.922,1.922c-1.061,0 -1.923,-0.861 -1.923,-1.922Z",
    style: {
      fill: "#f97655"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.187,4.526c0.021,1.399 1.136,2.535 2.534,2.582c1.398,0.048 2.587,-1.01 2.703,-2.403c0.116,-1.394 -0.882,-2.634 -2.268,-2.819c-1.155,0.674 -2.165,1.572 -2.969,2.64Z",
    style: {
      fill: "#f97655",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.995,16.267c1.736,2.471 4.501,4.018 7.515,4.205c0.012,-0.137 0.019,-0.276 0.019,-0.415c-0.001,-1.784 -1.006,-3.414 -2.6,-4.216c-1.593,-0.801 -3.502,-0.636 -4.934,0.426Z",
    style: {
      fill: "#f97655",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.345,82.721c0,-0.676 0.548,-1.224 1.224,-1.224c0.675,0 1.224,0.548 1.224,1.224c0,0.675 -0.549,1.224 -1.224,1.224c-0.676,0 -1.224,-0.549 -1.224,-1.224Z",
    style: {
      fill: "#666774"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.545,114.881c0,-0.676 0.548,-1.224 1.224,-1.224c0.675,0 1.224,0.548 1.224,1.224c0,0.675 -0.549,1.224 -1.224,1.224c-0.676,0 -1.224,-0.549 -1.224,-1.224Z",
    style: {
      fill: "#666774"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.065,121.841c0,-0.676 0.548,-1.224 1.224,-1.224c0.675,0 1.224,0.548 1.224,1.224c0,0.675 -0.549,1.224 -1.224,1.224c-0.676,0 -1.224,-0.549 -1.224,-1.224Z",
    style: {
      fill: "#666774"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.524,63.842c0,-0.675 0.548,-1.224 1.224,-1.224c0.676,0 1.224,0.549 1.224,1.224c0,0.676 -0.548,1.224 -1.224,1.224c-0.676,0 -1.224,-0.548 -1.224,-1.224Z",
    style: {
      fill: "#666774"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.544,35.7c0,-0.675 0.548,-1.224 1.224,-1.224c0.676,0 1.224,0.549 1.224,1.224c0,0.676 -0.548,1.224 -1.224,1.224c-0.676,0 -1.224,-0.548 -1.224,-1.224Z",
    style: {
      fill: "#666774"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.154,91.459c0,-0.675 0.549,-1.224 1.224,-1.224c0.676,0 1.224,0.549 1.224,1.224c0,0.676 -0.548,1.224 -1.224,1.224c-0.675,0 -1.224,-0.548 -1.224,-1.224Z",
    style: {
      fill: "#666774"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.24,92.897l1.09,0l0,-1.087l0.444,0l0,1.087l1.089,0l0,0.446l-1.089,0l0,1.087l-0.444,0l0,-1.087l-1.09,0l0,-0.446Z",
    style: {
      fill: "#666774",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,55.217l1.09,0l0,-1.087l0.444,0l0,1.087l1.089,0l0,0.446l-1.089,0l0,1.087l-0.444,0l0,-1.087l-1.09,0l0,-0.446Z",
    style: {
      fill: "#666774",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.671,34.166l1.09,0l0,-1.089l0.444,0l0,1.089l1.089,0l0,0.444l-1.089,0l0,1.09l-0.444,0l0,-1.09l-1.09,0l0,-0.444Z",
    style: {
      fill: "#666774",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.127,86.779l1.09,0l0,-1.087l0.444,0l0,1.087l1.087,0l0,0.447l-1.087,0l0,1.087l-0.444,0l0,-1.087l-1.09,0l0,-0.447Z",
    style: {
      fill: "#666774",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.982,122.962l1.087,0l0,-1.088l0.444,0l0,1.088l1.089,0l0,0.446l-1.089,0l0,1.087l-0.444,0l0,-1.087l-1.087,0l0,-0.446Z",
    style: {
      fill: "#666774",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.5,48.324l1.09,0l0,-1.087l0.444,0l0,1.087l1.089,0l0,0.444l-1.089,0l0,1.09l-0.444,0l0,-1.09l-1.09,0l0,-0.444Z",
    style: {
      fill: "#666774",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.42,62.484l1.09,0l0,-1.087l0.444,0l0,1.087l1.089,0l0,0.444l-1.089,0l0,1.09l-0.444,0l0,-1.09l-1.09,0l0,-0.444Z",
    style: {
      fill: "#666774",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.469,107.057l1.089,0l0,-1.09l0.444,0l0,1.09l1.088,0l0,0.444l-1.088,0l0,1.089l-0.444,0l0,-1.089l-1.089,0l0,-0.444Z",
    style: {
      fill: "#666774",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.535,175.711c0,-1.833 1.489,-3.321 3.322,-3.321c1.833,0 3.321,1.488 3.321,3.321c0,1.833 -1.488,3.322 -3.321,3.322c-1.833,0 -3.322,-1.489 -3.322,-3.322Z",
    style: {
      fill: "url(#_Linear30)"
    }
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.493,83.585c0.405,-0.537 0.914,-0.987 1.495,-1.325c1.828,-1.064 4.126,-0.868 5.748,0.489c1.622,1.357 2.219,3.585 1.494,5.572c-0.725,1.986 -2.617,3.306 -4.732,3.299l-0.316,0c-1.843,-0.118 -3.472,-1.237 -4.243,-2.915c-0.77,-1.678 -0.558,-3.643 0.554,-5.118l0,-0.002Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip31)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image32",
    x: 0,
    y: 0,
    width: "125px",
    height: "125px",
    transform: "matrix(-1.00536,0,-0,-1.00416,166.535,91.6201)"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.756,86.609c0,2.504 1.946,4.577 4.445,4.735l0.3,0c1.993,-0.002 3.773,-1.25 4.454,-3.124c0.681,-1.873 0.119,-3.973 -1.408,-5.255c-1.527,-1.282 -3.692,-1.472 -5.42,-0.477c-0.549,0.319 -1.03,0.744 -1.413,1.25c-0.626,0.826 -0.962,1.835 -0.958,2.871Z",
    style: {
      fill: "#8776d9",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.67,83.599c0.249,0.105 0.49,0.23 0.72,0.372c0.15,0.083 0.28,0.198 0.379,0.339c0.093,0.146 0.093,0.333 0,0.48c-0.141,0.138 -0.336,0.208 -0.533,0.192c-0.354,0.072 -0.72,-0.05 -0.96,-0.32l-0.408,-0.369c-0.142,-0.13 -0.298,-0.305 -0.24,-0.48c0.065,-0.135 0.196,-0.226 0.346,-0.24c0.35,-0.069 0.714,-0.005 1.02,0.18",
    style: {
      fill: "#f97655",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.124,88.481c0,-0.138 0.112,-0.25 0.25,-0.25c0.137,0 0.249,0.112 0.249,0.25c0,0.138 -0.112,0.249 -0.249,0.249c-0.138,0 -0.25,-0.111 -0.25,-0.249Z",
    style: {
      fill: "#f97655"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.378,86.899c0,-0.506 0.411,-0.917 0.917,-0.917c0.506,0 0.917,0.411 0.917,0.917c0,0.506 -0.411,0.917 -0.917,0.917c-0.506,0 -0.917,-0.411 -0.917,-0.917Z",
    style: {
      fill: "#f97655"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.714,83.76c0.008,0.666 0.537,1.207 1.203,1.231c0.665,0.024 1.232,-0.478 1.288,-1.141c0.056,-0.664 -0.418,-1.254 -1.078,-1.343c-0.549,0.32 -1.03,0.746 -1.413,1.253Z",
    style: {
      fill: "#f97655",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.62,89.342c0.826,1.177 2.143,1.915 3.578,2.004l0,-0.199c0.003,-0.853 -0.478,-1.635 -1.241,-2.017c-0.763,-0.383 -1.676,-0.3 -2.359,0.212l0.022,0Z",
    style: {
      fill: "#f97655",
      fillRule: "nonzero"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.582,
    y: 48.48,
    width: 24.72,
    height: 0.96
  })))), /*#__PURE__*/React.createElement("defs", null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "68px",
    height: "155px",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-9.20396e-16,15.0312,15.0312,9.20396e-16,139.027,148.116)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e6e6e6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#fdd376",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f97655",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-9.20396e-16,15.0312,15.0312,9.20396e-16,121.03,148.116)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e6e6e6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#fdd376",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f97655",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-9.20396e-16,15.0312,15.0312,9.20396e-16,109.757,148.116)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e6e6e6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#fdd376",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f97655",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-9.20396e-16,15.0312,15.0312,9.20396e-16,91.5624,148.116)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e6e6e6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#fdd376",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f97655",
      stopOpacity: 1
    }
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "_Image9",
    width: "148px",
    height: "45px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJQAAAAtCAYAAABI+UJpAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAFEklEQVR4nO1c247iOBCtsp2mX3ebafVqNFppPjOBOIGG/xyNVrNa7eW1RRzXPtDlMRACuUGgfSRk+sSXk/IZx3bMIATcLOI4/qVJ/vV6/d9QWhg4dAMB/SLPc2eioigAACCKIne9LEswxsBkMnGctRaKonCc1nowYwVD3Qi01r/2XWee5//2XWcw1A1gCDP56NNYwVAjx9BmYvRlqqsYqk2Qhhiex45LmYnRR4wvZqgkSZ6ICBAREH82a611HF+31gIAgBCiknt9ff3nUrqvhdls9gTQLj7WWpfWcVyWiICIeomt6FL4XMRx/EREAABARGCtdR+f45RxjIvj+OkSuq+FOI6fusTHT+s4v979620x6Ah1iY5fr9d3N1pd+x9Ml5gOZigesgEAJpMJvL297TzqHh4eYLPZ7JRRSoExxg3FAD+HZh76GVJKMMYAIt7VI5Dj1md8GFEUwWaz2eGq+ubx8RFms1mrmKo2hU5Baz31BZZlubP5BrAdXpU6bL6KA9gGzq+T8yIiZFk2zbLs7x6kXx1KKQToNz4MIjrgyrI84IwxrfX3PofSWk8BwE30+vpU1elz3O4tQ2s9HSo+bbg26PWRN4ZOzfO8l5Gqyb1co81LoM199WaoMQWjbQf3cQ9dzDWmGAK0u5fe5lBdnrvXRpIkU4B+7oHrWq1WjTojSZLpLceQ0cscioM4FjTRM5T2scXkUrjIxuZYMXSn37qp2ujvbKgsy6a8JSClBIDtcjWKIkBEEGLbhBACoihyy1tOoyhy5TiNosgtjzmNoshtPfgpf9/PdyoYaZpOL6Eny7KzOkVKuRMf/gwVH7++qv5iPU3R2VBEhESESilERHzfR0EiQiklCiFQKYVCCCQiFEI4XkqJROTKcUpECACuLua4HT/l71X5jmnWWn9CxIvp0Vp/qothlR7+DBmfuv5iPU398OEeeac6997a7YqmujsZauxB2tc3dr33gNbbBkmSPN/aMtcYc9UDhUmSPK9Wq7/8vwFue8tlH40MNZ/Pn4cSMjTGon0sOobCWYbSWr8MLWRoCF6+BDQG93+e53+eyltrKK31S5PTflUcg7lzT2zWnVJsosdHlZ59n7XRU8c1jc+Y9eR5/mKtrTVW3dL6t2PXAgLyPP9RxVcaKk3Tz8PKCbgHLBaLP/a5A0PN5/NgpoCzsVwud0y1Y6j5fP7lsnIC7gHL5fI7f3eG0lp/8Sdg/oSuKXfupLxuot627aDnOnryPP8O4O2UCyGwKAokIiyKwr1LKooCEfGAAwAsisK9eyqKAq217pqUEo0xWJYlGmPcuyIicry1FqWUri4uz++UuurhsnV6rLW1eowxJ/Vw/o+sh32EAABpmv4OAQEdsVgsvikAANz/uURAQEuoNE2/dvmVQ0CAD+HvlPo7r204ANiZwFVx/Le/0+vnGbueLhrvXY/W+qtCROSTewBwcDqwCbcv6Bjno6r8mPV00fgR9ChrbZg/BfQGRS2OeQYEHIMKK7yAPqGklMCPPSGEW+71wSEi7e2y4hEOELHXtoOe6+hRZVkib7mXZYk8a/c5/wxSHeevJnB7HueAIyL0/+sZvu7nDXpuV49CRDy2FPS/n8P56allKONU20HPbelRRCR8klHF+ack67hz69sX3rT8R9Czz41dj6LtD/8OMlVxZVmexZ1bXxXXJG/QMz496v1ssZuU8USsJeeeuxUcwPZltJvkvYtx3JHyQc8N6fkfSqewTEGKp44AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear10",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.14058e-15,34.9584,34.9584,2.14058e-15,156.593,140.753)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d6d6d6",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear11",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.34397e-15,38.28,38.28,2.34397e-15,156.679,145.646)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d6d6d6",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear12",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.34397e-15,38.28,38.28,2.34397e-15,78.8952,145.646)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d6d6d6",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear13",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.14058e-15,34.9584,34.9584,2.14058e-15,79.8576,148.968)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d6d6d6",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear14",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.93734e-15,31.6392,31.6392,1.93734e-15,117.089,152.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d6d6d6",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear15",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.38081e-15,22.5504,22.5504,1.38081e-15,139.286,161.378)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d6d6d6",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear16",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.1667e-15,19.0536,19.0536,1.1667e-15,95.4144,164.875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d6d6d6",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear17",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.38081e-15,22.5504,22.5504,1.38081e-15,62.376,161.378)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d6d6d6",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear18",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.38081e-15,22.5504,22.5504,1.38081e-15,169.003,161.378)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d6d6d6",
      stopOpacity: 1
    }
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    id: "_Image20",
    width: "6px",
    height: "6px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAS0lEQVQImW3MMQ6AMAxD0R/J6aG4Ws8NStWIsFDE0Dfalq33fgCYGUtVIXc/M/MLW2tkJppzXvyMMQCQpKgqe+9qDeTuNxuKiG3xANZJHIi76aF3AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear21",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-3.63867e-16,5.9424,5.9424,3.63867e-16,51.54,141.802)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d6d6d6",
      stopOpacity: 1
    }
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    id: "_Image23",
    width: "7px",
    height: "7px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAZklEQVQImWWMQQrDQAwD5ZUxeVMft99Owbbc04ZA56hBY3vvj5mhqkASb1zSd601ZmaSHrHWGgdwv8eDJHhm3iRhZgMAVWUAQBIeEU0SMwNJiIiThXe3uvsvSxJ+XZcyEzPziPP+AWtqMdaaj2JYAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear24",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.06779e-16,6.6432,6.6432,4.06779e-16,36.8568,172.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#c0c0c0",
      stopOpacity: 1
    }
  })), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    id: "_Image26",
    width: "8px",
    height: "8px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAT0lEQVQYlYWOwQ2AMAwDHctbMVzXBtTEfKAIkEqep7OdaK0tmJxsr5k5QESAJC6mqtreKdt3A8m19/4QSA5JAHZJ3+2TCUBNn8xMT4W/hgOGmCCru5XYhgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear27",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.49543e-16,7.3416,7.3416,4.49543e-16,186.482,152.114)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d6d6d6",
      stopOpacity: 1
    }
  })), _image6 || (_image6 = /*#__PURE__*/React.createElement("image", {
    id: "_Image29",
    width: "21px",
    height: "21px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA5klEQVQ4jeWUQW7FIAxEx2NzrJ4t544Ue7qCkib/S23YVLWEhJ7NgAeEbdv2gcURAPJ/ikqyyMwCAJKqKpsLSEqSSfoRGyetqsuuv2UBIN0dkk5JdwcAZH65QxIkcRzHYGYGdz+xiIgkiaoaohEBkpA0RCMCZjaGJLg7SJ4YydG+pl0AwGbWWoOkwSRdWK+rKgtJ2U/TbZjbdvfRQc/dsd7t8PTi/MMIANfrfCrq7gKAqjKSmpN3LDOtr3nFYt/3Pj8VvmPz87ljERF3Cx8FVwsCQHz3bIno5Ok60dbaH/FU88e4KD4BW/6r8x4zpt0AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear30",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.06779e-16,6.6432,6.6432,4.06779e-16,36.8568,172.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5f5f5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d6d6d6",
      stopOpacity: 1
    }
  })), _image7 || (_image7 = /*#__PURE__*/React.createElement("image", {
    id: "_Image32",
    width: "10px",
    height: "10px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAU0lEQVQYla2NOw6AQAhEh8+xvBoHVwNjI5uNFYUkNDOPh0TEgcE4gGsEkjx/N85Ad7+nxspMERGoKruoKgGwMgcAM+PXsB81WJPX2jaSa9+Me/YAlScwwrSczhQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdImgMissionMain);
export default __webpack_public_path__ + "static/media/fd_img_mission_main.518627e8.svg";
export { ForwardRef as ReactComponent };